export type shareLinkProps = {
  url: string;
  title: string;
  text: string;
};

export async function shareLink(shareData: shareLinkProps) {
  try {
    await navigator?.share(shareData);
  } catch (err) {
    console.error(err);
  }
}
